export default class GoogleMapsUtil {
	private static BASE_URL: string = 'https://maps.googleapis.com/maps/api/js';

	private static loadingPromise?: Promise<void>;

	/**
	 * Load Google Maps API
	 * The function makes sure the maps script is only appended to the page once, so that it can be called over and over
	 */
	public static async initApi(): Promise<void> {
		if (GoogleMapsUtil.loadingPromise) {
			return GoogleMapsUtil.loadingPromise;
		}

		let resolvePromise: () => void;
		GoogleMapsUtil.loadingPromise = new Promise((resolve: () => void): void => {
			resolvePromise = resolve;
		});

		document.body.appendChild(
			Object.assign(document.createElement('script'), {
				type: 'text/javascript',
				async: true,
				defer: true,
				src: `${GoogleMapsUtil.BASE_URL}?key=${
					(window as any).HARIBO.global.env.GOOGLE_MAPS_KEY
				}&libraries=places,geocoding`,
				onload: (): void => resolvePromise()
			})
		);

		return GoogleMapsUtil.loadingPromise;
	}
}
